module.exports = __webpack_public_path__ + "static/media/sv.2a44c324.svg";